import kitAxiosInstance from '../lib/kitAxios';

export const fetchTickets = async ({ queryKey }) => {
  const [_key, { currentPage, limit = 10, status, type }] = queryKey;
  const response = await kitAxiosInstance.get('/tickets', {
    params: { page: currentPage, limit, status, type },
  });
  return response.data;
};


export const fetchTicketById = async (id) => {
  const response = await kitAxiosInstance.get(`/tickets/${id}`);
  return response.data;
};


export const createTicketReply = async ({ id, message, attachments = [] }) => {
  const requestBody = attachments.length
    ? createMultipartBody({ message }, attachments)
    : { message };
  const response = await kitAxiosInstance.post(`/tickets/${id}/replies`, requestBody);
  return response.data;
};

const createMultipartBody = (fields, attachments) => {
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => formData.append(key, value));
  attachments.forEach((file) => formData.append('attachments', file));
  return formData;
};


export const updateTicketStatus = async ({ id, status }) => {
  const response = await kitAxiosInstance.patch(`/tickets/${id}`, { status });
  return response.data;
};


export const deleteTicketById = async (id) => {
  const response = await kitAxiosInstance.delete(`/tickets/${id}`);
  return response.data;
};
